import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import bmui_6qgoJ5AxSg from "/app/plugins/bmui.ts";
import countdown_olk6LFpgGt from "/app/plugins/countdown.ts";
import directives_8CcCirWtnE from "/app/plugins/directives.ts";
import ga_client_7dQ7yMojeg from "/app/plugins/ga.client.ts";
import im_client_8ex9Cq7J7y from "/app/plugins/im.client.ts";
import inject_worker_client_9HnSu1iw9h from "/app/plugins/inject-worker.client.ts";
import request_host_PNNsgYv6Ze from "/app/plugins/request-host.ts";
import setup_client_LCITs7LDia from "/app/plugins/setup.client.ts";
import vue_platform_all_3ZnWe25KPs from "/app/plugins/vue-platform-all.ts";
import websocket_worker_client_woUwPoBAnW from "/app/plugins/websocket-worker.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  bmui_6qgoJ5AxSg,
  countdown_olk6LFpgGt,
  directives_8CcCirWtnE,
  ga_client_7dQ7yMojeg,
  im_client_8ex9Cq7J7y,
  inject_worker_client_9HnSu1iw9h,
  request_host_PNNsgYv6Ze,
  setup_client_LCITs7LDia,
  vue_platform_all_3ZnWe25KPs,
  websocket_worker_client_woUwPoBAnW
]